import { useEffect, useState } from 'react';
import type { DataTableRowEventParams as GridRowParams } from '@/components/custom/erp';
import { useSaleOrderStatusData } from './useSalesOrderStatusData';
import { initialSearchValues, SearchFormValues } from '../schema';
import { orderStatusReportColumns } from '../cols-definition';

export interface UseTableDataReturn {
  tables: Array<{
    name: string;
    rows: BanHangRecord[];
    columns: BanHangRecord[];
  }>;
  handleRowClick: (params: GridRowParams) => void;
  isLoading: boolean;
  error: Error | null;
  refreshData: () => Promise<void>;
  totalItems: number;
  currentPage: number;
  handlePageChange: (page: number) => Promise<void>;
}

export function useTableData(
  searchParams: SearchFormValues = initialSearchValues,
  enabled = false
): UseTableDataReturn {
  const [selectedRowIndex, setSelectedRowIndex] = useState<string | null>(null);

  const { data, isLoading, error, refreshData, totalItems, currentPage, handlePageChange } = useSaleOrderStatusData(
    searchParams,
    enabled
  );

  const handleRowClick = (params: GridRowParams) => {
    const order = params.row as BanHangRecord;
    setSelectedRowIndex(params.row.id.toString());
    console.log('Row clicked:', order);
  };

  const tables = [
    {
      name: 'Báo cáo tình trạng đơn hàng mua',
      rows: data,
      columns: orderStatusReportColumns(
        () => {},
        () => {}
      )
    }
  ];

  return {
    tables,
    handleRowClick,
    isLoading,
    error,
    refreshData,
    totalItems,
    currentPage,
    handlePageChange
  };
}
